import { DaysForm } from '@dispatch/shared/types';
import { zonedTimeToUtc, utcToZonedTime, format } from 'date-fns-tz';

export const createDateWithTimeZoneOffset = (
  date: Date | string | number,
  timeZone: string
): Date => {
  if (!timeZone) {
    return new Date(date);
  }
  const result = zonedTimeToUtc(date, timeZone);
  if (!result.toJSON()) {
    return new Date(date);
  }
  return result;
};

export const createDatesOfWeek = (
  startDate: Date,
  endDate: Date
): Record<number, { startDate: Date | null; endDate: Date | null } | null> => {
  const dateOfDays: Record<
    number,
    { startDate: Date | null; endDate: Date | null } | null
  > = {
    0: null,
    1: null,
    2: null,
    3: null,
    4: null,
    5: null,
    6: null,
  };
  let day = startDate.getDay();

  while (!dateOfDays[day % 7]) {
    dateOfDays[day++ % 7] = {
      startDate: new Date(startDate),
      endDate: new Date(endDate),
    };
    startDate = getDateFromAddedDays(startDate, 1);
    endDate = getDateFromAddedDays(endDate, 1);
  }

  return dateOfDays;
};

export const createDayNumberArray = (values: DaysForm): Array<number> => {
  const days = [];
  if (values.sunday) {
    days.push(0);
  }
  if (values.monday) {
    days.push(1);
  }
  if (values.tuesday) {
    days.push(2);
  }
  if (values.wednesday) {
    days.push(3);
  }
  if (values.thursday) {
    days.push(4);
  }
  if (values.friday) {
    days.push(5);
  }
  if (values.saturday) {
    days.push(6);
  }

  return days;
};

export const getDateFromAddedDays = (date: Date, addDays: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + addDays);
  return result;
};

export const getTimeWithOffset = (
  timeZoneId: string | undefined,
  dateTime: Date | string | number
) => {
  if (!timeZoneId) {
    return new Date(dateTime);
  }
  const result = utcToZonedTime(dateTime, timeZoneId);
  if (!result.toJSON()) {
    return new Date(dateTime);
  }
  return result;
};

export const convertDateforMuiDatePicker = (date?: string | Date | null) => {
  try {
    if (!date) {
      return undefined;
    }

    return new Date(date).toISOString().slice(0, -5).replace('T', ' ');
  } catch {
    return undefined;
  }
};

export const formatLocationDate = (date?: string | Date | null) => {
  try {
    if (!date) {
      return undefined;
    }

    return format(new Date(date), 'yyyy-MM-dd');
  } catch {
    return undefined;
  }
};
